import { Controller } from "@hotwired/stimulus"

// Drag-and-drop for the lead pipeline kanban. Cards are draggable; dropping
// on a column posts the new stage to move_stage and moves the card on success.
export default class extends Controller {
  static targets = ["card", "dropzone"]
  static values = { urlTemplate: String }

  connect() {
    this.cardTargets.forEach(card => {
      card.addEventListener("dragstart", this.onDragStart)
    })
    this.dropzoneTargets.forEach(zone => {
      zone.addEventListener("dragover", this.onDragOver)
      zone.addEventListener("dragleave", this.onDragLeave)
      zone.addEventListener("drop", this.onDrop)
    })
  }

  onDragStart = (event) => {
    event.dataTransfer.setData("text/lead-id", event.currentTarget.dataset.leadId)
    event.dataTransfer.effectAllowed = "move"
  }

  onDragOver = (event) => {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
    event.currentTarget.classList.add("bg-gray-50")
  }

  onDragLeave = (event) => {
    event.currentTarget.classList.remove("bg-gray-50")
  }

  onDrop = (event) => {
    event.preventDefault()
    const zone = event.currentTarget
    zone.classList.remove("bg-gray-50")

    const leadId = event.dataTransfer.getData("text/lead-id")
    this.moveCard(leadId, zone.dataset.stage)
  }

  // Touch/mobile fallback: a per-card stage <select> (HTML5 drag events do
  // not fire on touch screens).
  moveViaSelect = (event) => {
    const select = event.currentTarget
    const moved = this.moveCard(select.dataset.leadId, select.value)
    // moveCard reverts the select if the request fails
    moved.then(ok => {
      if (!ok) {
        const card = this.cardTargets.find(c => c.dataset.leadId === select.dataset.leadId)
        select.value = card?.parentElement?.dataset?.stage || select.value
      }
    })
  }

  async moveCard(leadId, stage) {
    const card = this.cardTargets.find(c => c.dataset.leadId === leadId)
    const zone = this.dropzoneTargets.find(z => z.dataset.stage === stage)
    if (!leadId || !stage || !card || !zone || card.parentElement === zone) return false

    const url = this.urlTemplateValue.replace("%3Aid", leadId).replace(":id", leadId)

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({ stage })
      })

      if (response.ok) {
        zone.appendChild(card)
        this.refreshCounts()
        return true
      }
      return false
    } catch (_error) {
      // network failure: leave the card where it was
      return false
    }
  }

  refreshCounts() {
    this.dropzoneTargets.forEach(zone => {
      // Count card targets only — the mobile stage <select> inside each
      // card also carries data-lead-id, so a bare attribute selector
      // would double-count.
      const count = zone.querySelectorAll('[data-leads-kanban-target~="card"]').length
      const badge = zone.closest("section")?.querySelector(".owner-status-panel-header .owner-status-count")
      if (badge) badge.textContent = count
    })
  }
}
